// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1vctg","title":"Header_title__Nl6I6","side":"Header_side__3shjc"};